var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.question.fileRootCss }, [
    !_vm.question.isReadOnlyAttr &&
    !_vm.question.isDisabledAttr &&
    _vm.question.hasFileUI
      ? _c("input", {
          class: _vm.question.cssClasses.fileInput,
          attrs: {
            tabindex: "-1",
            type: "file",
            id: _vm.question.inputId,
            "aria-required": _vm.question.ariaRequired,
            "aria-label": _vm.question.ariaLabel,
            "aria-invalid": _vm.question.ariaInvalid,
            "aria-errormessage": _vm.question.ariaErrormessage,
            multiple: _vm.question.allowMultiple,
            title: _vm.question.inputTitle,
            accept: _vm.question.acceptedTypes,
            capture: _vm.question.renderCapture,
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.question.isReadOnlyAttr
      ? _c("input", {
          class: _vm.question.getReadOnlyFileCss(),
          staticStyle: { color: "transparent" },
          attrs: {
            type: "file",
            readonly: "",
            id: _vm.question.inputId,
            multiple: _vm.question.allowMultiple,
            placeholder: _vm.question.title,
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.question.isDisabledAttr
      ? _c("input", {
          class: _vm.question.getReadOnlyFileCss(),
          staticStyle: { color: "transparent" },
          attrs: {
            type: "file",
            disabled: "",
            id: _vm.question.inputId,
            multiple: _vm.question.allowMultiple,
            placeholder: _vm.question.title,
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: _vm.question.cssClasses.dragArea,
        on: {
          drop: _vm.question.onDrop,
          dragover: _vm.question.onDragOver,
          dragleave: _vm.question.onDragLeave,
          dragenter: _vm.question.onDragEnter,
        },
      },
      [
        _vm.question.showFileDecorator
          ? _c("div", { class: _vm.question.getFileDecoratorCss() }, [
              _vm.question.showDragAreaPlaceholder
                ? _c(
                    "span",
                    { class: _vm.question.cssClasses.dragAreaPlaceholder },
                    [
                      _c("survey-string", {
                        attrs: {
                          locString: _vm.question.locRenderedPlaceholder,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.question.cssClasses.wrapper },
                [
                  _vm.question.showChooseButton
                    ? _c("sv-file-choose-btn", {
                        attrs: { data: { question: _vm.question } },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.question.actionsContainerVisible
                    ? _c("sv-action-bar", {
                        attrs: { model: _vm.question.actionsContainer },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.question.isEmpty()
                    ? _c(
                        "span",
                        { class: _vm.question.cssClasses.noFileChosen },
                        [_vm._v(_vm._s(_vm.question.noFileChosenCaption))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.question.showRemoveButton
          ? _c("sv-file-clean-btn", {
              attrs: {
                question: _vm.question,
                css: _vm.question.showRemoveButton,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.question.showLoadingIndicator
          ? _c(
              "div",
              { class: _vm.question.cssClasses.loadingIndicator },
              [_c("sv-loading-indicator")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.question.isPlayingVideo
          ? _c("sv-file-video", { attrs: { question: _vm.question } })
          : _vm._e(),
        _vm._v(" "),
        _vm.question.allowShowPreview
          ? [_c("sv-file-preview", { attrs: { question: _vm.question } })]
          : _vm._e(),
        _vm._v(" "),
        _vm.question.showRemoveButtonBottom
          ? _c("sv-file-clean-btn", {
              attrs: {
                question: _vm.question,
                css: _vm.question.showRemoveButtonBottom,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.question.fileNavigatorVisible
          ? _c("sv-action-bar", {
              attrs: { model: _vm.question.fileNavigator },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }